import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import ReactModal from 'react-modal';

import Type from './Type';
import Input from '../../../../base_components/Input';
import {selectMicroservices} from '../../../../features/microservices.slice';
import {selectTypes} from '../../../../features/types.slice';
import {isEmptyObject} from '../../../../utils/utils';
import {types as defaultTypes} from '../../../../utils/settings';
import noTypeImage from '../../../../assets/frown-solid-cultured-50.png';

import styles from '../../../../styles/case/Modal.module.scss';
import buttonStyles from '../../../../styles/base_components/Button.module.scss';

const customStyles = {
  content: {
    maxWidth: 'calc(100vw - 200px)',
    maxHeight: 'calc(100vh - 100px)',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    border: 'none',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#303253',
    boxShadow: '#282840 0px 5px 15px'
  },
  overlay: {
    backgroundColor: 'rgba(40, 40, 46, 0.3)'
  }
};

function Modal(props) {
  const microservices = useSelector(selectMicroservices);
  const [types, setTypes] = useState({});
  const unavailable = isEmptyObject(types);
  const userTypes = useSelector(selectTypes);

  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  function createNode(event) {
    if (error) return;
    if (input.trim() === '') {
      setError('Enter a value in order to create the node.');
      return;
    }

    const selectedTypes = Object.keys(types).filter(type => types[type]);
    if (selectedTypes.length === 0) {
      setError('Choose a type in order to create the node.');
      return;
    }

    props.onAddNodes(selectedTypes, input);

    props.setShow(false);
    setInput('');
  }

  function toggleType(type) {
    return (event) => {
      event.stopPropagation();

      setTypes(types => {
        let newTypes = {...types};
        newTypes[type] = !types[type];

        if (newTypes[type]) setError('');
        return newTypes;
      })
    }
  }

  function closeModal() {
    props.setShow(false);
    setError('');
    setInput('');
    setTypes(types => {
      let newTypes = {};
      for (let type in types) newTypes[type] = false;
      return newTypes;
    });
  }

  useEffect(() => {
    function matchTypes() {
      setTypes(types => {
        let newTypes = {};
        for (let type in types) newTypes[type] = defaultTypes[type]?.match(input);
        return newTypes;
      });
    }

    if (input.trim() === '') {  // clear types
      setTypes(types => {
        let newTypes = {};
        for (let type in types) newTypes[type] = false;
        return newTypes;
      });
      return;
    }

    const timer = setTimeout(matchTypes, 10);
    return () => clearTimeout(timer);
  }, [input]);

  useEffect(() => {  // setTypes false
    function setAllTypes() {
      let t = {};
      for (let type in defaultTypes) {
        if (type === '*') continue;

        t[type] = false;
      }
      for (let type in userTypes) {
        t[type] = false;
      }
      setTypes(t);
    }

    const ids = Object.keys(microservices).filter(id => id !== '_persist');

    let t = {};
    for (let id of ids) {
      for (let fetcher of microservices[id].fetchers) {
        for (let type in fetcher.types) {
          if (type === '*') {
            setAllTypes();
            return;
          }

          t[type] = false;
        }
      }
    }
    setTypes(t);
  }, [microservices, userTypes]);
  
  return (
    <ReactModal isOpen={props.show} onRequestClose={closeModal} style={customStyles}>
      <div className={styles.modal}>
        <div className={styles.exit} onClick={closeModal}/>

        <div className={styles.form}>
          <Input
            autoFocus
            className={styles.input}
            placeholder='Enter the node value'
            value={input}
            setValue={setInput}
            error={error}
            setError={setError}
            onKeyUp={(e) => { e.keyCode === 13 && createNode()}}
          />
          <button className={buttonStyles.button} onClick={createNode} disabled={unavailable}>create node</button>
        </div>

        {unavailable ?
          <div className={styles.noType}>
            <img src={noTypeImage} alt='Frown Face Solid'/>
            <p>There are no available types</p>
          </div> :
          <div className={styles.types}>
            {Object.keys(types).sort().map(type => (
              <Type
                key={type}
                type={type}
                matched={types[type]}
                onClick={toggleType(type)}
              />
            ))}
          </div>
        }
      </div>
    </ReactModal>
  );
}

export default Modal;